import TokenIndex from "./js/TokenIndex.jsx";
import TokenForm from "./js/TokenForm.jsx";

const components = [
    TokenIndex, TokenForm
];

export default function (app) {
    components.forEach(com => app.component(com.name, com));
};